import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/fraudstatus`;

interface GetFileFraudReportQueryPayload {
  fileId: string;
}

export interface FileFraudReport {
  status: FRAUD_STATUS;
  fraudReason?: string;
  fraudCanceledDate?: Date;
  fraudReportedDate?: Date;
  fraudReportedByUser?: {
    userId: string;
    externalId: string;
    fullname: string;
  };
  fraudCanceledByUser?: {
    userId: string;
    externalId: string;
    fullname: string;
  };
}

export enum FRAUD_STATUS {
  FRAUD_CONFIRMED = 'FraudConfirmed',
  FRAUD_INVALIDATED = 'FraudInvalidated',
  NONE = 'none',
}

async function getFileFraudStatusQuery({
  fileId,
}: GetFileFraudReportQueryPayload): Promise<
  BackResponse<FileFraudReport> | BackResponseFailure
> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId);

    const response = await apiCall<BackResponse<FileFraudReport>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getFileFraudStatusQuery;
